export default __webpack_public_path__ + "static/media/undraw_Developer_activity_re_39tg.a4dc13de.svg";